import { ActionCreator } from "redux";
import {
	ActionType,
	ActiveReservationChangedAction,
	AdditionalInfoShownAction,
	AdditionalInfoHiddenAction,
	InfoBarToggledAction,
	ActiveAreaChangedAction
} from "./type";

export const setActiveArea: ActionCreator<ActiveAreaChangedAction> = (
	id: string
) => ({
	type: ActionType.OverviewActiveAreaChanged,
	payload: {
		id
	}
});

export const setActiveReservation: ActionCreator<
	ActiveReservationChangedAction
> = (id: string) => ({
	type: ActionType.OverviewActiveReservationChanged,
	payload: {
		id
	}
});

export const toggleInfoBar: ActionCreator<InfoBarToggledAction> = () => ({
	type: ActionType.OverviewInfoBarToggled
});

export const showAdditionalInfo: ActionCreator<
	AdditionalInfoShownAction
> = () => ({
	type: ActionType.OverviewAdditionalInfoShown
});

export const hideAdditionalInfo: ActionCreator<
	AdditionalInfoHiddenAction
> = () => ({
	type: ActionType.OverviewAdditionalInfoHidden
});
